// extracted by mini-css-extract-plugin
export default {"wrapper":"CWarsDebug_wrapper_d2902"};